import React, { useContext, useEffect } from "react";
import styled from "styled-components";
import Axios from "axios";
import DaumPostcode from "react-daum-postcode";

import globalContext from "../../../Hooks/globalContext";
import languagePack from "../../../Utils/language";
import { GAS_PRICE_API, GAS_PRICE_API_ESC, HOST, NUMBER_REGEX } from "../../../Utils/constants";
import { numberWithCommas, ToFixed } from "../../../Utils/util";
import useState from "../../../Hooks/useState";
import useInput from "../../../Hooks/useInput";
import Loader from "../../../Components/Common/Loader";
import PageWrapper from "../../../Components/Common/PageWrapper";
import GoBack from "../../../Components/Common/GoBack";
import Theme from "../../../Styles/Theme";
import { ClipLoader } from "react-spinners";
import AmountInput from "../../../Components/Common/Input";
import DefaultButton from "../../../Components/Common/DefaultButton";
import PinCode from "../../../Components/PinCodeOTP/Auth";
import PinCodeRegister from "../../../Components/PinCodeOTP/Register";

const Box = styled.div`
  width: 100%;
  padding: 12.5px 20px;
  background-color: white;
  margin-bottom: 5px;
`;

const InnerRow = styled.div`
  padding: 10px 5px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const InnerLabel = styled.div`
  color: ${(props) => props.theme.darkGrey};
`;

const InnerValue = styled.div`
  color: ${(props) => props.theme.darkGrey};
`;

const SectionTitle = styled.div`
  font-weight: 800;
  color: ${(props) => props.theme.black};
  font-size: 17px;
  margin-bottom: 10px;
`;

const AddressInputText = styled.div`
  color: #bcbcbe;
  text-align: right;
`;

const AddressWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

const AddressInputView = styled.div`
  border: 1px solid #e6e6e6;
  min-height: 38px;
  font-size: 13px;
  padding: 0px 15px;
  box-sizing: border-box;
  width: 100%;
  outline: none;
  opacity: 0.85;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  :hover {
    opacity: 0.75;
    cursor: pointer;
  }
`;

const PriceResultRow = styled(InnerRow)`
  padding: 20px 5px 10px 5px;
  margin-top: 10px;
  border-top: 1px solid ${(props) => props.theme.black};
`;

const ResultPrice = styled(InnerValue)`
  color: ${(props) => props.theme.black};
`;

const ButtonWrapper = styled.div`
  width: 100%;
  padding: 10px 15px;
`;

const Container = ({ history, match }) => {
  const { user, language, httpHeader, contract, web3 } = useContext(globalContext);

  const product = useState(null);
  const balance = useState(null);
  const amountInput = useInput({ defaultValue: "1", regex: NUMBER_REGEX });
  const addressDetailInput = useInput({ defaultValue: "" });
  const available = useState({ locked: null, staking: null });
  const gas = useState(null);
  const params = useState(null);
  const price = useState(null);
  const inputAddress = useState(user.postAddress);

  const code = useState(false);
  const post = useState(false);

  const nextOnPress = async () => {
    const { data } = await Axios.post(`${HOST}/user/otp/validation`, null, httpHeader());
    if (data.isNull === 1) {
      code.setState(2);
    } else {
      const {
        data: { admin_wallet: admin },
      } = await Axios.post(`${HOST}/api/config`, { column: `admin_wallet` }, httpHeader());

      const buyParams = {
        type: "MallBuy",
        amount: `${
          (Number(product.state.price_krw) * Number(amountInput.value)) /
          (Number(price.state.price_lcm) * Number(price.state.dollar_won))
        }`,
        to: admin,
        idSend: false,
        gas: gas.state,
        log: {
          productId: product.state.id,
          productAmount: amountInput.value,
          postAddress: inputAddress.state ? inputAddress.state : user.state.postAddress,
          postAddressDetail: addressDetailInput.value,
          marketcapId: price.state.id,
        },
      };
      params.setState(buyParams);
      code.setState(1);
    }
  };

  const getBalance = async () => {
    const lcmBalance = await contract.state.lcms.methods.balanceOf(user.state.address).call();
    const lcm = await web3.utils.fromWei(lcmBalance);
    balance.setState(lcm);
  };

  const getAvailable = async () => {
    const {
      data: { locked, staking },
    } = await Axios.post(`${HOST}/api/available/token`, null, httpHeader());
    available.setState({ locked: ToFixed(locked.sum - locked.available_amount, 10000), staking: staking.sum });
  };

  const getMarketCap = async () => {
    const { data } = await Axios.post(`${HOST}/api/marketcap`, null, httpHeader());
    const [first] = data;
    price.setState(first);
  };

  const addressOnPress = async () => {
    post.setState(true);
  };

  const goBackOnClick = () => {
    history.push(`/market/${match.params.productId}`);
  };

  //   useEffect(() => {
  //     if (address) {
  //       inputAddress.setState(address);
  //     }
  //   }, [address]);

  const getProduct = async () => {
    const { data } = await Axios.post(
      `${HOST}/market/product`,
      { id: match.params.productId, content: "exception" },
      httpHeader()
    );
    product.setState(data);
  };

  const postHandleComplete = async (data) => {
    inputAddress.setState(data.address);
    post.setState(false);
  };

  useEffect(() => {
    getMarketCap();
    Axios.get(GAS_PRICE_API_ESC).then((response) => {
      // const { data: esc } = await Axios.get(GAS_PRICE_API_ESC);
      const esc = response.data;
      const data = {
        safeLow: esc.result.SafeGasPrice * 10,
        average: esc.result.ProposeGasPrice * 10,
        fast: esc.result.FastGasPrice * 10,
        fastest: esc.result.FastGasPrice * 10,
      };
      gas.setState(data.fastest);
    });
    getProduct();
    getAvailable();
  }, []);

  useEffect(() => {
    if (contract.state) {
      addressDetailInput.setValue(user.state.postAddressDetail);
      getBalance();
    }
  }, [contract.state]);
  return code.state ? (
    <>
      {code.state === 1 && <PinCode params={params.state} />}
      {code.state === 2 && <PinCodeRegister />}
    </>
  ) : post.state ? (
    <DaumPostcode onComplete={postHandleComplete} animation={true} height={"100%"} />
  ) : (
    <PageWrapper>
      <GoBack onClick={goBackOnClick} />
      {product.state ? (
        <>
          <Box>
            <SectionTitle>{languagePack("상품 정보", language.state)}</SectionTitle>
            <InnerRow>
              <InnerLabel>{languagePack("상품명", language.state)}</InnerLabel>
              <InnerValue>{product.state.title}</InnerValue>
            </InnerRow>
          </Box>
          <Box>
            <SectionTitle>{languagePack("지갑 정보", language.state)}</SectionTitle>
            <InnerRow>
              <InnerLabel>{languagePack("LCMS 잔액", language.state)}</InnerLabel>
              <InnerValue>
                {balance.state ? (
                  numberWithCommas(ToFixed(balance.state)) + " LCMS"
                ) : (
                  <ClipLoader color={Theme.darkGrey} size={15} />
                )}
              </InnerValue>
            </InnerRow>
            <InnerRow>
              <InnerLabel>{"1 LCMS"}</InnerLabel>
              {price.state ? (
                <InnerValue>
                  {`${numberWithCommas(ToFixed(Number(price.state.price_lcm) * Number(price.state.dollar_won)))} ₩`}
                </InnerValue>
              ) : (
                <ClipLoader color={Theme.darkGrey} size={15} />
              )}
            </InnerRow>
          </Box>
          <Box>
            <SectionTitle>{languagePack("결제 정보", language.state)}</SectionTitle>
            <InnerRow>
              <InnerLabel>{languagePack("결제 금액", language.state)}</InnerLabel>
              <InnerValue>{numberWithCommas(product.state.price_krw) + " ₩"}</InnerValue>
            </InnerRow>
            <InnerRow>
              <InnerLabel>{languagePack("배송지", language.state)}</InnerLabel>
              <AddressWrapper>
                <AddressInputView>
                  {user.state ? (
                    inputAddress.state ? (
                      <AddressInputText onClick={addressOnPress} style={{ color: "black" }}>
                        {inputAddress.state}
                      </AddressInputText>
                    ) : (
                      <AddressInputText onClick={addressOnPress} style={{ color: "black" }}>
                        {user.state.postAddress}
                      </AddressInputText>
                    )
                  ) : (
                    <AddressInputText>{`* ${languagePack("주소", language.state)}`}</AddressInputText>
                  )}
                </AddressInputView>
                <AmountInput
                  style={{ marginTop: 5, borderRadius: 1, textAlign: "right" }}
                  placeholder=""
                  {...addressDetailInput}
                />
              </AddressWrapper>
            </InnerRow>
            <InnerRow>
              <InnerLabel>{languagePack("수량", language.state)}</InnerLabel>
              <div>
                <AmountInput
                  style={{ marginTop: 5, borderRadius: 1, textAlign: "right" }}
                  placeholder=""
                  {...amountInput}
                />
              </div>
            </InnerRow>
            <InnerRow>
              <InnerLabel>{languagePack("할인 금액", language.state)}</InnerLabel>
              <InnerValue>0 ₩</InnerValue>
            </InnerRow>
            <InnerRow>
              <InnerLabel>{languagePack("총 결제 금액", language.state)}</InnerLabel>
              <InnerValue>{numberWithCommas(Number(product.state.price_krw) * Number(amountInput.value))} ₩</InnerValue>
            </InnerRow>
            <PriceResultRow>
              <InnerLabel>{languagePack("결제", language.state)}</InnerLabel>
              {price.state ? (
                <ResultPrice>
                  {`${numberWithCommas(
                    ToFixed(
                      (Number(product.state.price_krw) * Number(amountInput.value)) /
                        (Number(price.state.price_lcm) * Number(price.state.dollar_won))
                    )
                  )} LCMS`}
                </ResultPrice>
              ) : (
                <ClipLoader color={Theme.darkGrey} size={15} />
              )}
            </PriceResultRow>
            <ButtonWrapper>
              <DefaultButton onClick={nextOnPress} text={languagePack("다음", language.state)} />
            </ButtonWrapper>
          </Box>
        </>
      ) : (
        <Loader color={Theme.darkGrey} size={15} />
      )}
    </PageWrapper>
  );
};

export default Container;
